"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root = function root(size, hasContent) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("background-size:cover;background-repeat:no-repeat;background-position:center center;", hasContent && "\n    position: relative;\n  ", ";", size ? "\n      width: ".concat(size, "px;\n      height: ").concat(size, "px;\n    ") : "\n      width: 100%;\n      height: 100%;\n    ", ";&[alt]:after{display:none;content:none;}")
  );
};

var content =
/*#__PURE__*/
(0, _emotion.css)("position:absolute;left:0;right:0;top:0;bottom:0;");
var _default = {
  root: root,
  content: content
};
exports.default = _default;